import React, { useState, memo } from 'react';
import { FormattedMessage } from 'react-intl';

import messages from './cookiesBar.messages';
import { Wrapper, Container, Content, Button, Link } from './cookiesBar.styles';
import { BUTTON_PRIMARY_TYPE } from '../button/button.constants';
import { renderWhenTrue } from '../../utils/rendering';
import { setCookiesAccepted, getHasAcceptedCookies } from '../../services/localStorage';
import { ROUTES } from '../../../routes/routes';

export const CookiesBar = memo(() => {
  const [isCookiesVisible, setCookies] = useState(getHasAcceptedCookies());

  const handleClick = () => {
    setCookiesAccepted();
    setCookies(false);
  };

  const renderCookiesBar = renderWhenTrue(() => (
    <Wrapper>
      <Container>
        <Content>
          <FormattedMessage
            {...messages.text}
            values={{
              link: (
                <Link to={ROUTES.standaloneCookies} openInternalInNewTab>
                  <FormattedMessage {...messages.link} />
                </Link>
              ),
            }}
          />
        </Content>
        <Button theme={BUTTON_PRIMARY_TYPE} dark onClick={handleClick}>
          <FormattedMessage {...messages.button} />
        </Button>
      </Container>
    </Wrapper>
  ));

  return renderCookiesBar(isCookiesVisible);
});
